import {
    Button,
    FormGroup,
    Input,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';

const PayedModal = ({ open, onClose }) => {
    const { invoice } = usePage().props;

    const { data, setData, errors, patch } = useForm({
        payed_at: '',
    });

    const handleSubmit = () => {
        patch(
            `/customers/${invoice.customer_id}/invoices/${invoice.id}/mark-as-payed`
        );

        onClose();
    };

    return (
        <Modal open={open} size='small' onClose={onClose}>
            <ModalHeader>Factuur markeren als betaald</ModalHeader>
            <ModalContent>
                <FormGroup>
                    <Input
                        label='Betaaldatum'
                        required
                        type='date'
                        value={data.payed_at || ''}
                        onChange={event =>
                            setData('payed_at', event.target.value)
                        }
                        error={errors.payed_at}
                    />
                </FormGroup>
            </ModalContent>
            <ModalActions>
                <Button type='button' onClick={onClose}>
                    Annuleren
                </Button>
                <Button variant='primary' type='submit' onClick={handleSubmit}>
                    Opslaan
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default PayedModal;
